export default "__VITE_ASSET__2Mi5__7F__"